import { CycleUtils } from '@wix/package-picker-shared';
/** Anchors on the monthly cycle deliberately — the API's per-cycle savings are relative to monthly. */
export const resolveComparisonPrice = (items, currentPricing) => {
  var _ref;
  const monthlyPricing = items.find(item => CycleUtils.isMonthly(item.cycle));
  return ((_ref = monthlyPricing ?? currentPricing) == null || (_ref = _ref.monthlyFinalPrice) == null ? void 0 : _ref.formattedAmount) ?? undefined;
};

/** Sale: campaign discount, only for a covered cycle. Off sale: cycle savings ('0' still badges). */
export const resolveBadgeSavingsAmount = _ref2 => {
  var _savings$fixedAmount;
  let {
    isSale,
    isSaleCycle,
    discountFixedAmount,
    savings
  } = _ref2;
  if (isSale) {
    return isSaleCycle ? (discountFixedAmount == null ? void 0 : discountFixedAmount.formattedAmount) ?? undefined : undefined;
  }
  return savings != null && (_savings$fixedAmount = savings.fixedAmount) != null && _savings$fixedAmount.amount ? savings.fixedAmount.formattedAmount ?? undefined : undefined;
};
export const resolveSwitchPricing = (pricingDetails, targetCycleId) => {
  var _pricingDetails$find;
  const targetCycle = CycleUtils.convertCycleIdToCycle(CycleUtils.validateCycleId(targetCycleId));
  return (pricingDetails == null || (_pricingDetails$find = pricingDetails.find(p => CycleUtils.isCycleEqual(p.cycle, targetCycle ?? undefined))) == null || (_pricingDetails$find = _pricingDetails$find.finalPrice) == null || (_pricingDetails$find = _pricingDetails$find.monthlyTotal) == null ? void 0 : _pricingDetails$find.formattedAmount) ?? undefined;
};
//# sourceMappingURL=upsellPricing.js.map